import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './router';
import reportWebVitals from './reportWebVitals';
import { AppComponent } from './app/di/AppComponent';
import './app/ui/assets/css/index.css';
import 'tw-elements';
import './app/ui/assets/admin/style.scss';
import 'react-loading-skeleton/dist/skeleton.css';
import 'moment/locale/id';
import 'react-multi-carousel/lib/styles.css';
import moment from 'moment';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import '@fontsource/poppins';

// Set time to local indonesia
moment.locale('id');

// Use App Component
AppComponent.init();

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
